// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"65a22215","456":"4eed312f","656":"e11d37ec","756":"be9f2fea","787":"25003fe8","968":"a04732aa"}[chunkId] + ".chunk.js";
};